import { render, staticRenderFns } from "./LinkedFormsCard.vue?vue&type=template&id=874de6f4&"
import script from "./LinkedFormsCard.vue?vue&type=script&lang=js&"
export * from "./LinkedFormsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports